<!--alx-->
<template>
    <div v-if="can('reports.citizenship')">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <router-link to="/" tag="li" class="breadcrumb-item"><a href="">{{i18n('Main')}}</a></router-link>
                <router-link to="/citizenship-reports" tag="li" class="breadcrumb-item"><a href="">Отчеты по гражданству</a></router-link>
            </ol>
        </nav>

        <div class="base_box_hdr">
            <div class="base_box_ttl">
                <div class="row">
                    <div class="col-sm-8">
                        <h1 class="title">Отчеты по гражданству</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="base_box_main">
            <nav>
                <div class="nav nav-tabs" id="nav-tab01" role="tablist">
                    <a class="nav-item nav-link active" id="nav-01-tab01" data-toggle="tab" href="#nav-01-1" role="tab"
                       aria-controls="nav-01-1" aria-selected="true">Отчет по гражданству</a>
                    <!--a class="nav-item nav-link" id="nav-02-tab02" data-toggle="tab" href="#nav-02-1" role="tab"
                       aria-controls="nav-02-1">Отчет2</a>
                    <a class="nav-item nav-link" id="nav-03-tab03" data-toggle="tab" href="#nav-03-1" role="tab"
                       aria-controls="nav-03-1">Отчет3</a-->
                </div>
            </nav>
            <div class="tab-content" id="nav-tabContent01">

                <div class="tab-pane fade show active" id="nav-01-1" role="tabpanel" aria-labelledby="nav-01-tab">
                    <div class="row m-3">
                        <div class="button-group">
                            <button type="button" class="btn base_btn waves-effect waves-light" @click="reportMonthly(1)">{{i18n('Generate month report')}}</button>
                            <button type="button" class="btn base_btn waves-effect waves-light" @click="reportDaily(1)">{{i18n('Generate daily report')}}</button>
                        </div>
                    </div>
                    <div class="row my-3">
                        <!--div class="col-sm-3 px-0">
                            <div class="form-inline">
                                <model-list-select :list="transporters"
                                                   :class="'ml-3'"
                                                   v-model="selectedTransporter"
                                                   option-value="id"
                                                   option-text="name" class="w-75"
                                                   :placeholder="i18n('Transporters')">
                                </model-list-select>
                                <a href="#" class="btn">
                                    <i class="mdi mdi-close ml-1" v-if="selectedTransporter !== null"
                                       @click.prevent="selectedTransporter = null"></i>
                                </a>
                            </div>
                        </div-->
                        
                        <div class="col-sm-3 px-0">
                            <div class="form-inline">
                                <model-list-select :list="routes"
                                                   :class="'ml-3'"
                                                   v-model="selectedRoute"
                                                   option-value="id"
                                                   option-text="name" class="w-75"
                                                   :placeholder="i18n('Routes')">
                                </model-list-select>
                                <a href="#" class="btn">
                                    <i class="mdi mdi-close ml-1" v-if="selectedRoute !== null"
                                       @click.prevent="selectedRoute = null"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-sm-3 px-0">
                            <div class="input-group day date">
                                <label class="col-form-label fs-12 pt-3 pr-2">{{i18n('Filter by date from')}}</label>
                                <datepicker
                                        v-model="fromDate"
                                        :inputClass="'form-control base_input'"
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="mdi mdi-calendar"
                                        format="dd.MM.yyyy" class="m_datepicker w-auto">
                                </datepicker>
                            </div>
                        </div>
                        <div class="col-sm-3 px-0">
                            <div class="input-group day date w-75">
                                <label class="col-form-label fs-12 pt-3 pr-2">{{i18n('by')}}</label>
                                <datepicker
                                        v-model="toDate"
                                        :inputClass="'form-control base_input'"
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="mdi mdi-calendar"
                                        format="dd.MM.yyyy" class="m_datepicker w-auto">
                                </datepicker>
                            </div>
                        </div>
                        <div class="col-sm-3 px-0">
                            <div class="button-group">
                                <button type="submit" class="btn base_btn solid_blue waves-effect waves-light"
                                        @click="getCitizenshipReports()">
                                    <span class="">{{i18n('To form')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive" id="table1">
                        <table class="table table-striped table-hover mb-0" ref="printTable">
                            <thead class="text-center">
                            <tr>
                                <th scope="col" rowspan="2">{{i18n('Departure date')}}</th>
                                <th scope="col" rowspan="2">{{i18n('Departure time')}}</th>
                                <th scope="col" rowspan="2">{{i18n('Route Name')}}</th>
                                <th scope="col" rowspan="2">{{i18n('Transporters')}}</th>
                                <!--th scope="col" rowspan="2">{{i18n('Trips')}}</th-->
                                <th scope="col" rowspan="2">{{i18n('Number of passengers')}}</th>
                                <th scope="col" colspan="3">{{i18n('Citizenship')}}</th>

                            </tr>
                            <tr>
                                <th scope="col">Uzb</th>
                                <th scope="col">Kaz</th>
                                <!--th scope="col">Rus</th-->
                                <th scope="col">{{i18n('others')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="report in reports">
                                <td>{{report.trip_time | moment('YYYY-MM-DD')}}</td>
                                <td>{{report.trip_time | moment('HH:mm')}}</td>
                                <td>{{report.route_name}}</td>
                                <td>{{report.transporter_name}}</td>
                                <!--td>{{report.trips_count}}</td-->
                                <td>{{report.passengers_count}}</td>
                                <td>{{report.uy_count}}</td>
                                <td>{{report.kz_count}}</td>
                                <!--td>{{report.rus_count}}</td-->
                                <td>{{report.oth_count}}</td>
                            </tr>
                            <tr v-if="reports.length > 0">
                                <td><b>{{i18n('Total')}}: </b></td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>{{reportsOneTotal.passengers}}</td>
                                <td>{{reportsOneTotal.uy_count}}</td>
                                <td>{{reportsOneTotal.kz_count}}</td>
                                <td>{{reportsOneTotal.oth_count}}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-show="!loading_states.list && reports.length === 0"
                             class="text-center pt-3 pb-3 border">
                            Нет данных
                        </div>
                        <div v-show="loading_states.list" class="text-center pt-3 pb-3 border">
                            <i class="mdi mdi-spin mdi-loading"></i> {{i18n('Loading')}}...
                        </div>
                    </div>
                    <div v-if="reports.length > 0" class="base_box_cnt">
                        <div class="button-group">
                            <!--button type="button" class="btn base_btn waves-effect waves-light"
                                    @click="downloadXlsForOne">
                                {{i18n('Export to Excel')}}
                            </button-->
                            <button type="button" class="btn base_btn waves-effect waves-light"
                                    @click="printData('table1')">{{i18n('Print out')}}
                            </button>
                        </div>
                    </div>
                </div>

                <!--div class="tab-pane fade" id="nav-02-1" role="tabpanel" aria-labelledby="nav-02-tab02">
                </div-->

                <!--div class="tab-pane fade" id="nav-03-1" role="tabpanel" aria-labelledby="nav-03-tab03">
                </div-->
            </div>
        </div>

    </div>


</template>

<script>
    import {ModelListSelect} from 'vue-search-select';
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";

    export default {
        name: "CitizenshipReports",
        components: {
            Datepicker,
            ModelListSelect,
        },
        mounted() {
            let script1 = document.createElement('script');
            script1.setAttribute('src', '/xls-export-assets/xlsx.full.min.js');
            document.head.appendChild(script1);
            let script2 = document.createElement('script');
            script2.setAttribute('src', '/xls-export-assets/fileSaver.js');
            document.head.appendChild(script2);
            let script3 = document.createElement('script');
            script3.setAttribute('src', '/xls-export-assets/fileSaver.js');
            document.head.appendChild(script3);
        },
        data() {
            return {
                fromDate: this.$moment().format('MM.DD.YYYY'),
                toDate: this.$moment().format('MM.DD.YYYY'),

                //transporters: [],
                routes: [],
                reports: [],
                reportsOneTotal: {},

                //selectedTransporter: null,
                selectedRoute: null,
                loading_states: {
                    list: false,
                },
            }
        },
        methods: {
            /*
            downloadXlsForOne() {
                let fileName = 'Реестр_кассовых_ведомостей_' + this.$moment(this.fromDate).format('DDMMYYYY') + '-' + this.$moment(this.toDate).format('DDMMYYYY') + '.xls';
                this.$api.download('xls.transporterOne', {
                    fromDate: this.$moment(this.fromDate),
                    toDate: this.$moment(this.toDate),
                    selectedTransporter: this.selectedTransporter
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response]));
                    console.log(response, response.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },
            */
            /*
            getTransporters() {
                this.$api.get('transporter-reports.get-transporters').then(({data}) => {
                    this.transporters = data;
                })
            },
            */

            getRoutes() {
                this.$api.get('routes.all')
                .then(res => {
                    this.routes = res.data;
                    //this.loading_items++;
                });
            },

            getCitizenshipReports() {
                this.loading_states.list = true;
                let postData = {};
                postData.fromDate = this.$moment(this.fromDate).startOf('day').format('Y-MM-DD');
                postData.toDate = this.$moment(this.toDate).endOf('day').format('Y-MM-DD');

                //if (this.selectedTransporter !== null) {
                //    postData.selectedTransporter = this.selectedTransporter;
                //}
                if (this.selectedRoute !== null) {
                    postData.selectedRoute = this.selectedRoute;
                }
                this.$api.post('citizenship-reports.load-citizenship', postData).then(({data}) => {
                    this.reports = data;

                    this.calculateOneTotal();
                }).finally(() => {
                    this.loading_states.list = false;
                });
            },

            printData(id) {
                let fontSize = this.$refs.printTable.style.fontSize;
                this.$refs.printTable.style.fontSize = '13.5px';
                this.displayNoneLoop = false;
                let mywindow = window.open('', 'PRINT');
                mywindow.document.write('<html><head><title>' + document.title + '</title>');
                mywindow.document.write('<link rel="stylesheet" href="/css/lib.css" />');
                mywindow.document.write('<link rel="stylesheet" href="/css/app.css" />');
                mywindow.document.write('<link rel="stylesheet" href="/print.css" />');
                mywindow.document.write('</head><body >');
                mywindow.document.write(document.getElementById(id).innerHTML);
                mywindow.document.write('</body></html>');

                mywindow.document.close();
                mywindow.focus();
                this.$refs.printTable.style.fontSize = fontSize;

                setTimeout(() => {
                    mywindow.print();
                    mywindow.close();
                }, 1000)
            },
            
            calculateOneTotal() {
                this.reportsOneTotal.passengers = this.reports.reduce((sum, a) => sum + a.passengers_count, 0);
                this.reportsOneTotal.uy_count = this.reports.reduce((sum, a) => sum + a.uy_count, 0);
                this.reportsOneTotal.kz_count = this.reports.reduce((sum, a) => sum + a.kz_count, 0);
                this.reportsOneTotal.oth_count = this.reports.reduce((sum, a) => sum + a.oth_count, 0);
            },
            

            reportMonthly(i) {
                let date = new Date();
                this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
                this.toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                this.getCitizenshipReports();
            },
            reportDaily(i) {
                this.fromDate = new Date();
                this.toDate = new Date();
                this.getCitizenshipReports();
            }
        },
        created() {
            //this.getTransporters();
            this.getRoutes();
        },
        filters: {
            moneyFormat(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
            },
        }
    }
</script>

<style scoped>
    .custom-class {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .select-with {
        width: 28%;
    }

    .button-width {
        width: 16%;
        float: right;
    }

    div#table {
        white-space: nowrap;
    }
</style>
